import {PortableTextMarkComponentProps} from '@portabletext/react';
import {Link} from '@shopify/hydrogen';
import clsx from 'clsx';
import {resolvePath} from '~/lib/utils';

export const LinkInternalAnnotation = (
  props: PortableTextMarkComponentProps,
) => {
  if (props.value) {
    const path = resolvePath(props.value.docType, props.value.slug);

    if (path) {
      return (
        <Link
          className={clsx(
            'inline-flex items-center underline transition-opacity duration-200',
            'hover:opacity-60',
          )}
          to={path}
        >
          <>{props.children}</>
        </Link>
      );
    } else {
      return <>{props.children}</>;
    }
  } else return null;
};
